import React from 'react'
import { selectIsPJGeoentity } from '../../store/geoentity/geoentity.selectors'
import { withEverySelectorTruthy } from '../utils/react-redux'
import s from './GeoentitySourcePj.less'

function GeoentitySourcePj() {
  return <div className={s.main}>Source : Pages Jaunes</div>
}

export default withEverySelectorTruthy(selectIsPJGeoentity)(GeoentitySourcePj)
